import reducer from "./reducers";

import * as loginOps from "./operations";
import * as loginTypes from "./types";

export { loginOps, loginTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/login/index.js